import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOffice365 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 53.59 64.356",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.496 51.609V13.092L34.568.501l18.517 5.925v51.849l-18.517 5.582L.496 51.609l34.072 4.1V10.871l-22.221 5.185v30.369z",
		fill: "#eb3c00"
	})
});
export default SvgOffice365;
